import Gator from "gator";
import Headroom from "headroom.js";

let header;

_gg.onReady.PageHeader = () => {
    let body = document.body;
    let shrinkOn = 150;

    let distanceY = window.pageYOffset || document.documentElement.scrollTop;
    body.classList[distanceY > shrinkOn ? 'add' : 'remove']('-logo-inheader');

    window.addEventListener('scroll', () => {
        let distanceY = window.pageYOffset || document.documentElement.scrollTop;
        body.classList[distanceY > shrinkOn ? 'add' : 'remove']('-logo-inheader');
    });
};
Gator(_gg.html).on("click", ".nav-element.-level1.-hassub > a", event => {
    event.stopPropagation();
});

Gator(_gg.html).on("click", ".nav-element.-level1.-hassub", function() {
    this.classList.toggle("-listopen");
});
